var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVisits(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5V3.5C17.5 2.57174 17.8688 1.6815 18.5251 1.02513C19.1815 0.368749 20.0717 0 21 0H66.5C67.4283 0 68.3185 0.368749 68.9749 1.02513C69.6313 1.6815 70 2.57174 70 3.5V49C70 49.9283 69.6313 50.8185 68.9749 51.4749C68.3185 52.1313 67.4283 52.5 66.5 52.5H52.5V66.4755C52.5 68.4215 50.9285 70 48.9755 70H3.5245C3.06153 70.0005 2.60301 69.9096 2.17519 69.7327C1.74737 69.5557 1.35865 69.2961 1.03128 68.9687C0.703905 68.6413 0.44431 68.2526 0.26735 67.8248C0.0903905 67.397 -0.0004587 66.9385 1.74146e-06 66.4755L0.0105018 21.0245C0.0105018 19.0785 1.582 17.5 3.535 17.5H17.5ZM24.5 17.5H48.9755C50.9215 17.5 52.5 19.0715 52.5 21.0245V45.5H63V7H24.5V17.5ZM22.7605 56L42.5565 36.2005L37.6075 31.2515L22.7605 46.102L15.33 38.675L10.381 43.624L22.7605 56Z",
    fill: "#72C0B0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisits);
export default __webpack_public_path__ + "static/media/visits.3715721889f2af261e781b1ca2ca2368.svg";
export { ForwardRef as ReactComponent };